import {createReducer, createTypes} from 'reduxsauce'
import {merge, keys} from 'ramda'
import api from '../Services/api'
import {filterByIgreja, filterByEndereco} from '../Celula/filters'
import {celulaTypes} from './celulaRedux'

const types = createTypes(`
  FETCH_IGREJAS
`)

export default {
  fetchIgrejas: () => (dispatch) => {
    api.fetchIgrejas().then(res => {
      dispatch({
        type: types.FETCH_IGREJAS,
        payload: res.data,
        error: !res.ok
      })
    })
  }
}

const initialState = {}

const fetchIgrejas = (state, {payload, error}) => {
  if (error) return state
  return payload
}

const getIgrejas = (state, {payload, error}) => {
  if (error) return state
  return payload.igrejas
}


export const reducer  = createReducer(initialState, {
  [celulaTypes.FETCH_CELULAS]: getIgrejas
})


export const selectIgrejas = state =>
  keys(state.igrejas).map(key => state.igrejas[key])



// WEBPACK FOOTER //
// ./src/Redux/igrejaRedux.js